module.exports = __webpack_public_path__ + "img/9788949123035.602ba0f8.jpg";